export const pt = {
  joinNewsletter:
    "Assine nossa newsletter para se manter atualizado(a) sobre recursos e lançamentos",
};
